export const UnderlyingListMotive = {
    TakingProfits: "takingProfits",
    FearOfMissingOut: "fearOfMissingOut",
    JumpingTheShip: "jumpingTheShip",
    BuyingTheDip: "buyingTheDip",
} as const;
export type UnderlyingListMotive = (typeof UnderlyingListMotive)[keyof typeof UnderlyingListMotive];

export const UNDERLYING_LIST_MOTIVES: ReadonlyArray<UnderlyingListMotive> = [
    UnderlyingListMotive.TakingProfits,
    UnderlyingListMotive.FearOfMissingOut,
    UnderlyingListMotive.JumpingTheShip,
    UnderlyingListMotive.BuyingTheDip,
];

export const UnderlyingListTradeDirection = {
    Buy: "buy",
    Sell: "sell",
} as const;
export type UnderlyingListTradeDirection = (typeof UnderlyingListTradeDirection)[keyof typeof UnderlyingListTradeDirection];

export const UnderlyingListPriceTrend = {
    Rising: "rising",
    Falling: "falling",
} as const;
export type UnderlyingListPriceTrend = (typeof UnderlyingListPriceTrend)[keyof typeof UnderlyingListPriceTrend];

interface IUnderlyingListMotiveConfig {
    titleKey: `trading-motives.${string}`;
    tileLabelKey: `trading-motives.${string}`;
    tradeDirection: UnderlyingListTradeDirection;
    priceTrend: UnderlyingListPriceTrend;
}

export const UNDERLYING_LIST_MOTIVE_CONFIG = {
    [UnderlyingListMotive.TakingProfits]: {
        titleKey: "trading-motives.taking-profits",
        tileLabelKey: "trading-motives.taking-profits",
        tradeDirection: UnderlyingListTradeDirection.Sell,
        priceTrend: UnderlyingListPriceTrend.Rising,
    },
    [UnderlyingListMotive.FearOfMissingOut]: {
        titleKey: "trading-motives.fear-of-missing-out",
        tileLabelKey: "trading-motives.fear-of-missing-out-short",
        tradeDirection: UnderlyingListTradeDirection.Buy,
        priceTrend: UnderlyingListPriceTrend.Rising,
    },
    [UnderlyingListMotive.JumpingTheShip]: {
        titleKey: "trading-motives.jumping-the-ship",
        tileLabelKey: "trading-motives.jumping-the-ship",
        tradeDirection: UnderlyingListTradeDirection.Sell,
        priceTrend: UnderlyingListPriceTrend.Falling,
    },
    [UnderlyingListMotive.BuyingTheDip]: {
        titleKey: "trading-motives.buying-the-dip",
        tileLabelKey: "trading-motives.buying-the-dip",
        tradeDirection: UnderlyingListTradeDirection.Buy,
        priceTrend: UnderlyingListPriceTrend.Falling,
    },
} as const satisfies Record<UnderlyingListMotive, IUnderlyingListMotiveConfig>;

export type UnderlyingListMotiveColor = "red" | "green";

const TRADE_DIRECTION_COLOR: Record<UnderlyingListTradeDirection, UnderlyingListMotiveColor> = {
    [UnderlyingListTradeDirection.Sell]: "red",
    [UnderlyingListTradeDirection.Buy]: "green",
};

export const getUnderlyingListMotiveColor = (motive: UnderlyingListMotive): UnderlyingListMotiveColor =>
    TRADE_DIRECTION_COLOR[UNDERLYING_LIST_MOTIVE_CONFIG[motive].tradeDirection];

export const UnderlyingListDaysCount = {
    Seven: 7,
    Thirty: 30,
} as const;
export type UnderlyingListDaysCount = (typeof UnderlyingListDaysCount)[keyof typeof UnderlyingListDaysCount];

export const UNDERLYING_LIST_VISIBLE_ITEMS_COUNT = 5;

export const UNDERLYING_LIST_COLUMN_GAP_PX = 80;

export const UnderlyingListOverlayPlacement = {
    SpanningColumns: "spanning-columns",
    CompactOnly: "compact-only",
} as const;
export type UnderlyingListOverlayPlacement = (typeof UnderlyingListOverlayPlacement)[keyof typeof UnderlyingListOverlayPlacement];
